import { testimonials } from "@/mocks/data";

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="container-page">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            用户的<strong>真实声音</strong>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            听听我们的用户怎么说。他们的幸福故事，就是我们最大的动力。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((test) => (
            <div
              key={test.id}
              className="p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={test.avatar}
                    alt={test.name}
                    className="w-full h-full object-cover"
                    title={`${test.name} - 爱情岛用户`}
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {test.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {test.age}岁 · {test.city}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{test.content}"
              </p>
              <div className="flex gap-1 mt-4 text-accent-400">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}